/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePersonaGroupRequest
 */
export interface UpdatePersonaGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonaGroupRequest
     */
    name?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdatePersonaGroupRequest
     */
    biasIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdatePersonaGroupRequest
     */
    narrativeMappingIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePersonaGroupRequest
     */
    userIds?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePersonaGroupRequest
     */
    classifierId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePersonaGroupRequest
     */
    proxyId?: number | null;
}

/**
 * Check if a given object implements the UpdatePersonaGroupRequest interface.
 */
export function instanceOfUpdatePersonaGroupRequest(value: object): value is UpdatePersonaGroupRequest {
    return true;
}

export function UpdatePersonaGroupRequestFromJSON(json: any): UpdatePersonaGroupRequest {
    return UpdatePersonaGroupRequestFromJSONTyped(json, false);
}

export function UpdatePersonaGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePersonaGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'biasIds': json['bias_ids'] == null ? undefined : json['bias_ids'],
        'narrativeMappingIds': json['narrative_mapping_ids'] == null ? undefined : json['narrative_mapping_ids'],
        'userIds': json['user_ids'] == null ? undefined : json['user_ids'],
        'classifierId': json['classifier_id'] == null ? undefined : json['classifier_id'],
        'proxyId': json['proxy_id'] == null ? undefined : json['proxy_id'],
    };
}

export function UpdatePersonaGroupRequestToJSON(json: any): UpdatePersonaGroupRequest {
    return UpdatePersonaGroupRequestToJSONTyped(json, false);
}

export function UpdatePersonaGroupRequestToJSONTyped(value?: UpdatePersonaGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'bias_ids': value['biasIds'],
        'narrative_mapping_ids': value['narrativeMappingIds'],
        'user_ids': value['userIds'],
        'classifier_id': value['classifierId'],
        'proxy_id': value['proxyId'],
    };
}

